// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__JxBJJ","sidebar__nav":"sidebar_sidebar__nav__gzcDu","sidebar__nav__links":"sidebar_sidebar__nav__links__4tnBR"};